import { OpenInNew } from "@mui/icons-material";
import { Button, Link, Typography } from "@mui/material";
import { ExtendedSessionType } from "./OnlineSession";
import { useGetGoogleMeeting } from "../../utils";
import { useEffect } from "react";
import { useStore } from "../../../../store/store";


type MeetingURLButtonProps = {
    session: ExtendedSessionType
    updateMeetingCache: ({meeting_id, meeting_url}:{meeting_id:string, meeting_url: string}) => void
    meetingName: string
};

export const MeetingURLButton = ({session, updateMeetingCache, meetingName}: MeetingURLButtonProps) => {
    const { notifications } = useStore();
    const { data: gMeetData, status: statusMeeting, isFetchedAfterMount} = useGetGoogleMeeting(
        session.id
    );
    const isValidMeeting = gMeetData?.exists

        useEffect(() => {
            if (
                statusMeeting === "success" &&
                !isValidMeeting &&
                isFetchedAfterMount
            ) {
                updateMeetingCache({ meeting_id: "", meeting_url: "" });

                if (gMeetData?.error) {
                    notifications.setNotification({
                        isOpen: true,
                        message: gMeetData.error,
                        severity: "error",
                    });
                    return;
                }

                notifications.setNotification({
                    isOpen: true,
                    message: `${meetingName} anterior cancelada pelo Google Calendar`,
                    severity: "warning",
                });
            }
        }, [isValidMeeting, statusMeeting, isFetchedAfterMount]);
    
  return (
    <Link href={session.meeting_url} target="_blank" rel="noopener noreferrer">
    <Button
        variant="outlined"
        color="primary"
        endIcon={<OpenInNew />}
        disableElevation
        size="large"
    >
        <Typography variant="body1">URL da {meetingName}</Typography>
    </Button>
</Link>
  );
};